import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { UserOutlined } from "@ant-design/icons";
import { Avatar } from "antd";
import { format, NumberKind } from "./numberUtils";
import { productToString } from "./productToString";
export const getUserAvatar = (username, userDisplayName) => (_jsx(Avatar, { icon: _jsx(Avatar, { style: userDisplayName ? { backgroundColor: '#2264DC', color: 'white' } : undefined, icon: !userDisplayName ? _jsx(UserOutlined, {}) : null, children: userDisplayName === null || userDisplayName === void 0 ? void 0 : userDisplayName.replace(/ /g, '').split('').filter(c => c === c.toUpperCase()).join('') }), style: { backgroundColor: 'transparent' }, src: `${process.env.REACT_APP_BASE_API_URL}/api/users/${encodeURIComponent(username || '')}/profileimage` }));
export const renderPayoutNotification = (payout) => {
    const icon = getUserAvatar(payout.username, payout.userDisplayName);
    const message = (_jsxs("div", { style: { display: 'flex', gap: '12px' }, children: [format(payout.amount, { type: NumberKind.Currency }), " - ", productToString(payout.product), " - ", payout.bankName] }));
    const description = (_jsx("div", { style: { color: 'rgba(0, 0, 0, 0.45)' }, children: payout.userDisplayName || payout.team }));
    return {
        icon,
        message,
        description,
        className: 'payout-notification'
    };
};
